export class CreateOrganizationIdpGroupResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "group",
            "baseName": "group",
            "type": "OrganizationIdpGroup",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateOrganizationIdpGroupResponse.attributeTypeMap;
    }
    constructor() {
    }
}
